module.exports = __webpack_public_path__ + "img/it.0da133dd.svg";